// 多选
import { sysList } from '@/api/setting/sys'
import { areaList } from '@/api/setting/area'
import locationApi from '@/api/location.js'

export const locationSelectMixin = {
  data () {
    return {
      queryArea: {
        areaName: undefined, //	名称
        level: 3, // 等级（1：省 2：市 3：区）
        parentId: undefined //	父类ID
      },
      districtList: [],

      queryBusinessDisParam: {
        districtIds: undefined // 区域IDs
      },
      businessDistrictList: [],

      queryStreetParam: {
        businessDistrictId: undefined //	商圈ID
      },
      streetList: []

    }
  },

  methods: {
    // 区域改变事件 ==》商圈列表
    regionChange (val) {
      console.log('regionChange', val)
      this.form.districtIdList = val
      if (!(val && val.length > 0)) {
        this.form.streetIdList = []
        this.form.businessDistrictIdList = []
        this.businessDistrictList = []
        this.streetList = []
        return
      }

      this.queryBusinessDisParam.districtIds = val// 区域ID
      // const ids = val ? val.join(',') : undefined
      // 获取商圈列表
      locationApi.businessDistrictListByIds(this.queryBusinessDisParam).then((res) => {
        if (res.code === 200) {
          const businessDisList = res.data
          this.businessDistrictList = JSON.parse(JSON.stringify(businessDisList))
          const businessDisIdArr = this.form.businessDistrictIdList
          const newBusinessDisIdArr = []
          for (const item of businessDisList) {
            console.log(businessDisIdArr, item.id)
            if (businessDisIdArr.indexOf(item.id) > -1) {
              newBusinessDisIdArr.push(item.id)
            }
          }
          this.form.businessDistrictIdList = newBusinessDisIdArr
          console.log(this.form.businessDistrictIdList)
          this.businessDistrictMethod(this.form.businessDistrictIdList)
        }
      })
    },
    // 商圈改变事件==》街道列表
    businessDistrictMethod (val) {
      if (!(val && val.length > 0)) {
        this.form.streetIdList = []
        this.streetList = []
        return
      }
      this.queryStreetParam.businessDistrictId = val //	商圈ID
      // const ids = val ? val.join(',') : undefined
      locationApi.streetListByIds(this.queryStreetParam).then((res) => {
        if (res.code === 200) {
          const streetList = res.data
          this.streetList = JSON.parse(JSON.stringify(streetList))
          const streetIdArr = this.form.streetIdList
          const newStreetIdArr = []
          for (const item of streetList) {
            if (streetIdArr.indexOf(item.id) > -1) {
              newStreetIdArr.push(item.id)
            }
          }
          this.form.streetIdList = newStreetIdArr
        }
      })
    },
    // 区域列表
    getDistrict () {
      let companyInfo = localStorage.getItem('companyInfo')
      companyInfo = JSON.parse(companyInfo)
      if (companyInfo) {
        this.queryArea.parentId = companyInfo.companyCityId
        this.getArea()
      } else {
        this.getCompanyInfo(() => {
          this.getArea()
        })
      }
    },
    getCompanyInfo (func) {
      const param = { pageNum: 1, pageSize: 1 }
      sysList(param).then((response) => {
        if (response.code === 200) {
          const resData_ = response.data
          this.total = resData_.total
          if (this.total > 0) {
            this.list = resData_.records
            this.dataObj = resData_.records[0]
            this.sys = this.dataObj
            localStorage.setItem('companyInfo', this.sys)
            this.queryArea.parentId = this.sys.companyCityId
            if (func) {
              func()
            }
          } else {
            this.queryArea.parentId = ''
            this.$message.error('公司设置所在市信息获取失败')
          }
        }
      })
    },

    getArea () {
      // console.log(this.queryArea)
      areaList(this.queryArea).then((res) => {
        if (res.code === 200) {
          const resData = res.data
          const areaList = []
          if (resData != null && resData.length > 0) {
            for (let i = 0; i < resData.length; i++) {
              areaList.push({ areaId: resData[i].areaId, areaName: resData[i].areaName, children: [] })
            }
            this.districtList = areaList
            // console.log(this.districtList)
          }
        }
      })
    }
  },
  created () {
     // 区域列表
     this.getDistrict()
  }

}
